<template>
  <div>
    <mobile-dropdown v-if="$md.mobile() && !$md.tablet()" 
      :active="modalActive"
      :title="$t('main.DRAWER_AGENT')"
      :iconUrl="'/ics/property/img/templates/icon/recommend.svg'"
      :optionName="mobileButtonText"
      @toggle="toggleFilter" />

    <filter-button v-else
      :name="buttonText"
      :active="buttonActive"
      @click.native="toggleFilter">
      <dropdown-symbol :active="modalActive"/>
    </filter-button>

    <filter-modal
      :active="modalActive"
      :min-width="minWidth"
      @close="modalActive = false"
    >
        <md-checkbox
          value="isMitaclub"
          :checked="isMitaclub"
          @change="change"
        >
          {{ $t('find.MITACLUB') }}
        </md-checkbox>

        <md-checkbox
          value="isManager"
          :checked="isManager"
          @change="change"
        >
          {{ $t('find.MANAGER') }}
        </md-checkbox>

        <md-checkbox
          value="isSales"
          :checked="isSales"
          @change="change"
        >
          {{ $t('find.SALES') }}
        </md-checkbox>
    </filter-modal>
  </div>
</template>

<script>
import MobileDropdown from '@/components/Stock/MobileDropdown';
import MdCheckbox from '@/components/MaterialCheckbox';
import FilterButton from '@/components/Stock/Filters/Button';
import FilterModal from '@/components/Stock/Filters/Modal';
import DropdownSymbol from '@/components/DropdownSymbol';

export default {
  props: [ 'isMitaclub', 'isManager', 'isSales' ],
  components: {
    MobileDropdown,
    MdCheckbox,
    FilterButton,
    FilterModal,
    DropdownSymbol
  },
  data () {
    return {
      modalActive: false,
    }
  },
  methods: {
    change(evt) {
      const checked = evt.target.checked;
      const filterKey = evt.target.value;      
      this.$emit('changeAgentType', { [filterKey]: checked ? '1' : null });
    },
    toggleFilter(){
      this.modalActive = !this.modalActive;
    },
  },
  computed: {
    minWidth(){
      let w = '400px';
      if (this.$md.mobile() && !this.$md.tablet()) {
        w = '0px';
      }
      return w;
    },
    buttonActive() {
      return this.selectedFilters > 0;
    },
    buttonText() {
      return this.selectedFilters > 0 ?
        `${this.$t('main.SELECTED_FILTER')} (${this.selectedFilters})` : this.$t('main.DRAWER_AGENT');
    },
    mobileButtonText() {
      return this.selectedFilters > 0 ?
        `${this.$t('main.SELECTED_FILTER')} (${this.selectedFilters})` : this.$t('find.ALL_AGENT');
    },
    selectedFilters() {
      let ret = 0;
      if (this.isMitaclub) {
        ret += 1;
      }
      if (this.isManager) {
        ret += 1;
      }
      if (this.isSales) {
        ret += 1;
      }
      return ret;
    }
  },
};
</script>

<style scoped>
</style>